/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteRucLicensesParams,
  GetRucLicensesParams,
  PatchRucLicensesParams,
  PostRucLicensesParams,
  PostgrestError,
  RucLicenses,
  RucLicensesInsertPayload,
  RucLicensesUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRucLicensesResponse200 = {
  data: RucLicenses[]
  status: 200
}

export type getRucLicensesResponse206 = {
  data: RucLicenses[]
  status: 206
}

export type getRucLicensesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getRucLicensesResponseSuccess = (getRucLicensesResponse200 | getRucLicensesResponse206) & {
  headers: Headers;
};
export type getRucLicensesResponseError = (getRucLicensesResponseDefault) & {
  headers: Headers;
};

export type getRucLicensesResponse = (getRucLicensesResponseSuccess | getRucLicensesResponseError)

export const getGetRucLicensesUrl = (params?: GetRucLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/ruc_licenses?${stringifiedParams}` : `${backendBaseUrl}/ruc_licenses`
}

/**
 * @summary Read rows from `ruc_licenses`.
 */
export const getRucLicenses = async (params?: GetRucLicensesParams, options?: RequestInit): Promise<getRucLicensesResponse> => {

  const res = await fetch(getGetRucLicensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRucLicensesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRucLicensesResponse
}


export type postRucLicensesResponse201 = {
  data: RucLicenses[]
  status: 201
}

export type postRucLicensesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postRucLicensesResponseSuccess = (postRucLicensesResponse201) & {
  headers: Headers;
};
export type postRucLicensesResponseError = (postRucLicensesResponseDefault) & {
  headers: Headers;
};

export type postRucLicensesResponse = (postRucLicensesResponseSuccess | postRucLicensesResponseError)

export const getPostRucLicensesUrl = (params?: PostRucLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/ruc_licenses?${stringifiedParams}` : `${backendBaseUrl}/ruc_licenses`
}

/**
 * @summary Insert one or more rows into `ruc_licenses`.
 */
export const postRucLicenses = async (rucLicensesInsertPayload: RucLicensesInsertPayload,
    params?: PostRucLicensesParams, options?: RequestInit): Promise<postRucLicensesResponse> => {

  const res = await fetch(getPostRucLicensesUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rucLicensesInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRucLicensesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRucLicensesResponse
}


export type patchRucLicensesResponse200 = {
  data: RucLicenses[]
  status: 200
}

export type patchRucLicensesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchRucLicensesResponseSuccess = (patchRucLicensesResponse200) & {
  headers: Headers;
};
export type patchRucLicensesResponseError = (patchRucLicensesResponseDefault) & {
  headers: Headers;
};

export type patchRucLicensesResponse = (patchRucLicensesResponseSuccess | patchRucLicensesResponseError)

export const getPatchRucLicensesUrl = (params?: PatchRucLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/ruc_licenses?${stringifiedParams}` : `${backendBaseUrl}/ruc_licenses`
}

/**
 * @summary Update the rows of `ruc_licenses` matching the given filters.
 */
export const patchRucLicenses = async (rucLicensesUpdate: RucLicensesUpdate,
    params?: PatchRucLicensesParams, options?: RequestInit): Promise<patchRucLicensesResponse> => {

  const res = await fetch(getPatchRucLicensesUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rucLicensesUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchRucLicensesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchRucLicensesResponse
}


export type deleteRucLicensesResponse200 = {
  data: RucLicenses[]
  status: 200
}

export type deleteRucLicensesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteRucLicensesResponseSuccess = (deleteRucLicensesResponse200) & {
  headers: Headers;
};
export type deleteRucLicensesResponseError = (deleteRucLicensesResponseDefault) & {
  headers: Headers;
};

export type deleteRucLicensesResponse = (deleteRucLicensesResponseSuccess | deleteRucLicensesResponseError)

export const getDeleteRucLicensesUrl = (params?: DeleteRucLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/ruc_licenses?${stringifiedParams}` : `${backendBaseUrl}/ruc_licenses`
}

/**
 * @summary Delete the rows of `ruc_licenses` matching the given filters.
 */
export const deleteRucLicenses = async (params?: DeleteRucLicensesParams, options?: RequestInit): Promise<deleteRucLicensesResponse> => {

  const res = await fetch(getDeleteRucLicensesUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteRucLicensesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteRucLicensesResponse
}


